import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAnalyticsWithConsent } from '../../hooks/useAnalyticsWithConsent';
import { useAuth } from '../../auth/firebaseAuth';
import ManagedPropertyPortfolio from '../../components/managed-properties/ManagedPropertyPortfolio';
import ComplianceDashboard from '../../components/landlord-dashboard/ComplianceDashboard';
import AddManagedPropertyQuickAction from '../../components/landlord-toolkit/AddManagedPropertyQuickAction';
import ViewManagedPropertiesQuickAction from '../../components/landlord-toolkit/ViewManagedPropertiesQuickAction';
import PublicListingsDashboardQuickAction from '../../components/landlord-toolkit/PublicListingsDashboardQuickAction';
import ManageViewingsQuickAction from '../../components/landlord-toolkit/ManageViewingsQuickAction';
import { AvailableFeaturesSection } from '../../components/landlord-toolkit/AvailableFeatures';
import ToolkitHeader from '../../components/landlord-toolkit/ToolkitHeader';
import HelpSection from '../../components/landlord-toolkit/HelpSection';
import LandlordToolkitLayout from '../../components/landlord-toolkit/LandlordToolkitLayout';
import BookDemoCard from '../../components/landlord-toolkit/BookDemoCard';
import LandlordRulesInsight from '../../components/landlord-toolkit/LandlordRulesInsight';

const LandlordToolkitDashboard: React.FC = () => {
  const analytics = useAnalyticsWithConsent();
  const { currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    analytics.trackPixelCustom('landlord_toolkit_viewed', {
      content_name: 'Landlord Toolkit',
      content_type: 'dashboard',
    });
  }, []);

  return (
    <LandlordToolkitLayout>
      {/* Header Section */}
      <ToolkitHeader />

      {!currentUser && (
        <div className="bg-blue-50 border border-blue-100 text-blue-900 rounded-xl p-4 sm:p-5 mb-6 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
          <div>
            <h3 className="text-lg font-semibold">Create a free account to use the toolkit</h3>
            <p className="text-sm sm:text-base text-blue-800 mt-1">
              Sign up to add managed properties, track compliance, and access your landlord
              dashboard.
            </p>
          </div>
          <button
            onClick={() => navigate(`/signup?returnUrl=${encodeURIComponent('/landlord-toolkit')}`)}
            className="inline-flex justify-center items-center px-4 py-2 bg-blue-600 text-white text-sm sm:text-base font-semibold rounded-lg shadow-sm hover:bg-blue-500 transition-colors w-full sm:w-auto"
          >
            Create free account
          </button>
        </div>
      )}

      {/* Quick Actions Container */}
      <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
        <div className="grid gap-6 md:grid-cols-2">
          <AddManagedPropertyQuickAction />
          <ViewManagedPropertiesQuickAction />
          <ManageViewingsQuickAction />
          <PublicListingsDashboardQuickAction />
          <BookDemoCard />
        </div>
      </div>

      <div className="space-y-8">
        <ManagedPropertyPortfolio />

        {currentUser && (
          <section>
            <ComplianceDashboard />
          </section>
        )}

        {/* Irish Landlord Rules Insight */}
        <LandlordRulesInsight />

        {/* Available Features */}
        <AvailableFeaturesSection />

        {/* Book a Demo Card */}
        <BookDemoCard />
        {/* Help Section */}
        <HelpSection />
      </div>
    </LandlordToolkitLayout>
  );
};

export default LandlordToolkitDashboard;
